<template>
  <div id="Markets">
    <div class="size12px">- Binance 기준</div>
    <table class="type3">
      <thead slot="head">
        <th>Symbol</th>
        <th>Time</th>
        <th>Content</th>
        <th style="width:30px;">&nbsp;</th>
      </thead>
      <tbody slot="body">
        <tr v-for="row in values" :key="row.id">
          <td class="coinName" style="padding:5px 0;">
            <div>{{ row.symbol1 }}</div>
            <div class="font999">{{row.symbol2}}</div>
            <div class="size12px font999">{{ row.symbol1KR }}</div>
          </td>
          <td class="num tah font999">
            <span v-html="row.time"></span>
          </td>
          <td class="num tah">
            <span v-html="row.txt"></span>
            <div class="size11px">{{ row.eventTypeKR }}</div>
          </td>
          <td>&nbsp;</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'Markets',
  data () {
    return {
      searching: '',
      values: [],
      isModalView: false,
      coinSite: {},
      coinName: {},
      coinPrice: {},
      coinPriceUpbit: {},
      coinPriceBithumb: {},
      coinPriceCoinone: {}
    }
  },
  methods: {
    fetchData: function (coinName) {
      this.$axios
        .get('https://wisebody.co.kr/api/getBinance_data.php', {
          params: {
            coinName: coinName
          }
        })
        .then(res => {
          if (res.status === 200) {
            this.$root.$refs.H.lastUpdateDate = res.data.WDATE
            this.$root.$refs.MENU.TCAP = res.data.TCAP
            this.$root.$refs.MENU.TPER = res.data.TPER
            this.$root.$refs.MENU.TBTC = res.data.TBTC
            this.$root.$refs.MENU.TBTCPER = res.data.TBTCPER
            this.$root.$refs.MENU.usd_naver_top = res.data.AUSD_TOP
            this.$root.$refs.F.usd_naver = res.data.AUSD
            this.$root.$refs.F.usdt = res.data.AUSDT
            if (res.data.TOTAL === 0) {
              this.values = []
            } else {
              this.values = res.data.list
            }
          } else {
            console.log('Server Error')
          }
        })
        .catch(e => {
          console.error(e.message)
        })
    },
    fnSearch: function (e) {
      this.fetchData(e.target.value.toUpperCase())
    }
  },
  created () {
    this.$root.$refs.M = this
    this.fetchData()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/markets.vue